@if (showPanel$ | async) {
  <mat-expansion-panel class="panel">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ 'ASSOCIATIONS.ACCOUNT.TITLE' | translate }}</mat-panel-title>
    </mat-expansion-panel-header>
    @if (accountGroupInfo$ | async; as accountGroupInfo) {
      <crm-association-card
        *ngIf="accountGroupInfo?.id !== ''"
        [cardData]="accountGroupInfo"
        [actions]="accountGroupActions$ | async"
        [showEditTagButton]="false"
        [showRemoveButton]="false"
      >
        @if (canAccessRetailBilling()) {
          <ul class="no-bullets">
            <li>
              <a [routerLink]="'/businesses/accounts/' + accountGroupInfo.accountGroupCompanyId + '/subscriptions'">{{
                'NAV_ITEMS.BILLING.SUBSCRIPTIONS' | translate
              }}</a>
            </li>
            <li>
              <a [routerLink]="'/businesses/accounts/' + accountGroupInfo.accountGroupCompanyId + '/invoices'">{{
                'NAV_ITEMS.BILLING.INVOICES' | translate
              }}</a>
            </li>
            <li>
              <a [routerLink]="'/businesses/accounts/' + accountGroupInfo.accountGroupCompanyId + '/payments'">{{
                'NAV_ITEMS.BILLING.PAYMENTS' | translate
              }}</a>
            </li>
            <li>
              <a [routerLink]="'/businesses/accounts/' + accountGroupInfo.accountGroupCompanyId + '/credit-notes'">{{
                'NAV_ITEMS.BILLING.CREDIT_NOTES' | translate
              }}</a>
            </li>
          </ul>
        }
      </crm-association-card>
    } @else {
      @if (isAccountGroupLoading()) {
        <button mat-stroked-button color="primary" class="button-create-account" type="button" disabled>
          <glxy-loading-spinner [size]="'small'"></glxy-loading-spinner>
        </button>
      } @else {
        <button mat-stroked-button color="primary" class="button-create-account" (click)="createAccount()">
          <mat-icon>add</mat-icon>
          {{ 'ASSOCIATIONS.ACCOUNT.CREATE_ACCOUNT' | translate }}
        </button>
        <p class="description">{{ 'ASSOCIATIONS.ACCOUNT.CREATE_DESCRIPTION' | translate }}</p>
      }
    }
  </mat-expansion-panel>
}
